import { gsap, Power3, Power0, Back, splitColor } from 'gsap';
import { SanEngineManager } from '../../engine/SanEngineManager';
import { SanSymbolData } from "../../engine/Symbol/SanSymbolData";
import { SanRevealerSymbol } from "../../engine/Symbol/SanRevealerSymbol";
import { SanQuentin2 } from "../../SanQuentin2";
import { StateHandler } from "../../../core/utils/StateHandler";
import { ArrayHelper } from "../../../core/utils/ArrayHelper";
import { Helper } from '../../../core/utils/Helper';
import { SoundConfig } from '../../config/sound/SoundConfig';
import { GameConfig } from '../../config/base/GameConfig';
import { TextStyleConfig } from '../../config/translate/TextStyleConfig';
import { SoundManager } from '../../config/sound/SoundManager';
import { Sequence } from '../../../core/displayobject/Sequence';
import { ReelSymbolStates } from '../../../core/reel/symbol/ReelSpriteSymbolArea';
import { SanSpriteSymbol } from '../../engine/Symbol/SanSpriteSymbol';
import { OverlayItem } from '../../component/OverlayAnimation';
import { BLEND_MODES } from 'pixi.js';

export class ReavealerState extends StateHandler {
    public static readonly NORMAL: string = "normal";
    public static readonly EXPANDING: string = "expandig";
    public static readonly SPLITTER: string = "split";
    public static readonly EXTRA_FS: string = "extra_fs";
}

export class RevealSpinner extends PIXI.Container {

    private shuffleArray: string[] = [
        "M1",
        "M2",
        "M3",
        "M4",
        "M5",
        "M2",
        "M3",
        "M4",
        "M5",
        "M2",
        "M3",
        "M4",
        "M5",
        "M2",
        "M3",
        "M4",
        "M5",
        "XS",
        "XWAYS",
    ];

    public shuffleSym_Res: string[] = [
        "M1",
        "M2",
        "M3",
        "M4",
        "M5",
    ];

    private shuffleTime: number = 0.06;
    private shuffleAlpha: number = 0.5;

    private seq_xWays: Sequence

    private seq_res: SanRevealerSymbol;
    private seq_filler: SanRevealerSymbol;

    private shuffle_tl: gsap.core.Timeline;
    private expand_tl: gsap.core.Timeline;

    private resSymbol: string;

    private maskCont: PIXI.Container;
    private maskElement: PIXI.Graphics;

    private loopIndex: number = 0;

    public playBounceSound: boolean = false;
    public playBounceSoundSlice: boolean = false;

    public overlayGlow:OverlayItem;

    private specSym: { sym:string, val:number};

    public get shuffleTL(): gsap.core.Timeline {
        return this.shuffle_tl;
    }

    public get normalSym():SanRevealerSymbol{
        return this.seq_res;
    }

    private get halfSymHeight(): number {
        return SanSymbolData.fetchSymHeightSize(2);
    }

    private get halfhalfSymHeight(): number {
        return SanSymbolData.fetchSymHeightSize(1);
    }

    constructor() {
        super();
        ArrayHelper.shuffle(this.shuffleArray);
        this.initItems();
    }

    private nextShuffleSpritePath():string{
        this.loopIndex++;
        return this.CurrentShuffleValue[this.loopIndex % this.CurrentShuffleValue.length];
    }

    private get CurrentShuffleValue(): string[] {
        return this.shuffleArray;
    }

    private set CurrentShuffleValue(val: string[]) {
            this.shuffleArray = val;
    }

    public hideSequenceAlpha(value: boolean): void {
        if (value) {
            this.seq_filler.alpha = 0;
            this.seq_res.alpha = 0;
        } else {
            this.seq_filler.alpha = 1;
            this.seq_res.alpha = 1;
        }
    }

    private initItems(): void {
        const arrToMessWith: string[] = this.shuffleSym_Res;
        const starySymPath: string = arrToMessWith[Math.floor(Math.random() * arrToMessWith.length) % arrToMessWith.length];

        this.maskCont = this.addChild(new PIXI.Container());
        this.seq_res = this.maskCont.addChild(new SanRevealerSymbol(0, starySymPath, "normal", 2));
        this.seq_filler = this.maskCont.addChild(new SanRevealerSymbol(0, starySymPath, "normal", 2));
        this.seq_filler.y = -this.halfSymHeight;

        this.seq_xWays = this.addChild(new Sequence(SanQuentin2.assetLoader.getTextures("M/7/M_normal")))
        this.seq_xWays.anchor.set(0.5);
        this.seq_xWays.alpha = 0;

        if (!SanQuentin2.apiPlugin.gameClientConfiguration.showNearMissGfx) {
            this.hideSequenceAlpha(true);
        }

        this.maskElement = this.createGraphic();
        this.mask = this.maskElement;

        this.useMasking(false);

        this.sortChildren();
        this.maskCont.sortChildren();
    }

    useIndividualMasking(): void {
        if (this.shuffle_tl && this.shuffle_tl.isActive()) {
            this.useMasking(true);
        }
    }

    useOverlayGlow(val:boolean,xWays?:boolean,Split?:boolean):void{
       if(this.overlayGlow && !val){
            this.overlayGlow.timeline.pause();
            gsap.to(this.overlayGlow.item,{alpha:0,duration:0.25}).eventCallback("onComplete",() => {
                if(this.overlayGlow && this.overlayGlow.item && this.overlayGlow.item.parent){
                    this.overlayGlow.item.alpha = 0;
                    this.overlayGlow.timeline.kill();
                    this.overlayGlow.item.destroy();
                    this.overlayGlow = undefined!;
                }
            })
            return;
       }
       if(val){
            const path:string = xWays ? "Blink_Xways" : Split ? "Blink_Splitter" : "Blink_Block";
            if(!this.overlayGlow){
                this.overlayGlow = SanQuentin2.overlay.playSequence(this,SanQuentin2.assetLoader.getTextures(path));
                this.overlayGlow.timeline.fromTo(this.overlayGlow.item,{alpha:0},{alpha:1,duration:0.25},0);
                this.overlayGlow.timeline.to(this.overlayGlow.item,{alpha:0.8,duration:1.4,repeat:-1,yoyo:true},0);
                this.overlayGlow.timeline.to(this,{duration:Infinity},0);
                this.overlayGlow.item.scale.set(1, xWays || Split ? 1 : 0.5);
                (this.overlayGlow.item as Sequence).blendMode = BLEND_MODES.ADD;
            }else{
                const toScale = xWays || Split ? 1 : 0.5;
                const tl = Helper.setTimeline();
                tl.fromTo(this.overlayGlow.item.scale,{x:toScale,y:toScale},{x:toScale*1.15,y:toScale*1.15,duration:0.075});
                tl.to(this.overlayGlow.item.scale,{x:toScale,y:toScale,duration:0.075});
                // this.overlayGlow.item.scale.set(1, xWays || Split ? 1 : 0.5);
                (this.overlayGlow.item as Sequence).setTexture(SanQuentin2.assetLoader.getTextures(path))
            }
       }
    }

    public useMasking(val: boolean): void {
        // return;
        this.maskElement.visible = val;
        this.mask = val ? this.maskElement : null!;
        this.seq_filler.alpha = val ? 1 : 0;
    }

    private createGraphic(): PIXI.Graphics {
        const graphicBg: PIXI.Graphics = new PIXI.Graphics();

        const c: number = 0x000000;
        graphicBg.beginFill(c, 1);

        graphicBg.drawRect(-SanSymbolData.DEFAULT_DIM.WIDTH * 0.5, -(this.halfhalfSymHeight + 2),
            SanSymbolData.DEFAULT_DIM.WIDTH, this.halfSymHeight + 2);

        graphicBg.endFill();
        this.addChild(graphicBg);
        return graphicBg;
    }

    public shuffle(active: boolean,onStarted:Function): gsap.core.Timeline {
        if (active) {
            const spinStartDurr: number = SanEngineManager.getReel(0).startDuration;
            const ease: any = SanEngineManager.getReel(0).startEase;;//  SanEngineManager.isQuickStop ? GameConfig.REEL_ENGINE_CONFIG.EASING.QUICK_START : GameConfig.REEL_ENGINE_CONFIG.EASING.START; 
            this.CurrentShuffleValue = ArrayHelper.shuffle(this.CurrentShuffleValue);
            this.seq_filler.setSymbol(this.nextShuffleSpritePath());
            this.shuffle_tl = Helper.setTimeline(this.shuffle_tl, {
                onStart: () => {
                    this.seq_filler.alpha = 1;
                },
                onComplete: () => {
                    onStarted();
                    this.createLoop(active)
                }
            });
            this.shuffle_tl.add(this.seq_res.changeState({state:ReelSymbolStates.SPIN,duration:spinStartDurr}),0);
            this.shuffle_tl.add(this.seq_filler.changeState({state:ReelSymbolStates.SPIN,duration:spinStartDurr}),0);

            this.shuffle_tl.fromTo(this.maskCont.position, { y: 0 }, { duration:spinStartDurr, y: this.halfSymHeight, ease: ease }, 0)
            this.shuffle_tl.to(this, {duration:spinStartDurr / 2, alpha: this.shuffleAlpha }, spinStartDurr / 2)
            this.shuffle_tl.play();
        } else {
            this.createLoop(active);
        }
        return this.shuffle_tl;
    }

    private createLoop(active: boolean): void {
        if (active) {
            this.hideSequenceAlpha(false);

            this.seq_res.setSymbol(this.seq_filler.symName);
            this.seq_filler.setSymbol(this.nextShuffleSpritePath());

            this.shuffle_tl = Helper.setTimeline(this.shuffle_tl, 
                {
                    repeat: -1, repeatDelay: 0,
                    onRepeat: () => {
                        this.seq_res.setSymbol(this.seq_filler.symName);
                        this.seq_filler.setSymbol(this.nextShuffleSpritePath());
                    }
                });

            this.shuffle_tl.add(() => { this.alpha = this.shuffleAlpha }, 0)
            this.shuffle_tl.fromTo(this.maskCont.position, { y: 0 }, { duration:this.shuffleTime, y: this.halfSymHeight, ease: Power0.easeNone as any }, 0)
            this.shuffle_tl.play();
        } else {
            this.shuffle_tl = Helper.setTimeline(this.shuffle_tl, {
                onComplete: () => {
                    this.maskCont.position.y = 0;
                    this.seq_res.setSymbol(this.resSymbol);
                    if(this.playBounceSound){
                        if(this.seq_res.isXWays || this.seq_res.isSplit)
                            this.useOverlayGlow(true, this.seq_res.isXWays, this.seq_res.isSplit)
                        else{
                            this.useOverlayGlow(false);
                        }
                    }
                    
                    if(this.specSym && this.specSym.sym == this.resSymbol)
                        this.seq_res.isSpecial(this.specSym.val,0.25);

                    this.seq_res.markNonWin(false);
                    this.useMasking(false);
                }
            });
            
            this.seq_res.setSymbol(this.seq_filler.symName);
            this.seq_filler.setSymbol(this.resSymbol);

            const stopDurr = SanEngineManager.getReel(0).stopDuration;
            const stopease = SanEngineManager.getReel(0).stopEase;

            this.shuffle_tl.add(this.seq_res.changeState({state:ReelSymbolStates.NORMAL,duration:stopDurr / 2}),0);
            this.shuffle_tl.add(this.seq_filler.changeState({state:ReelSymbolStates.NORMAL,duration:stopDurr / 2}),0);

            this.shuffle_tl.fromTo(this.maskCont.position, stopDurr / 2, { y: 0 }, { y: this.halfSymHeight, ease: Back.easeOut.config(1.6) as any },0);
            // this.shuffle_tl.fromTo(this.maskCont.position,stopDurr/2,{y:0},{y:this.halfSymHeight, ease: Back.easeIn.config(1.6)});
            this.shuffle_tl.add(() => {
                if (this.playBounceSound) {
                    // SoundManager.playSoundEffect(SoundConfig.REELS_DEFAULT_BOUNCE[0]);
                    SoundManager.stopSoundEffect(SoundConfig.BAR_LANDING_BOUNCE)
                    SoundManager.playSoundEffect(SoundConfig.BAR_LANDING_BOUNCE);
                    if (this.playBounceSoundSlice) SoundManager.playSoundEffect(SoundConfig.REVEAL_RAZOR_BOUNCE);
                }
            }, stopDurr / 4)

            this.shuffle_tl.play();
        }
    }

    public setResultTexture(symPath: string): void {
        this.resSymbol = symPath;
    }

    public setSpecial(_sym:string,_val:number){
        if(!this.specSym || this.specSym.sym != _sym)
            this.specSym = {sym:_sym,val:_val};
    }

    public prepareForExpand(isWildReveal: boolean, isTop: boolean, revType:string): void {

        this.seq_res.changeState({sym:revType,forceState:true,state:ReelSymbolStates.NORMAL});
        let texture: PIXI.Texture[];

        // if (isWildReveal) {
        //     texture = SanQuentin2.assetLoader.getTextures(isTop ? "M/7/M_normal_top" : "M/7/M_normal_bottom");
        // }
        // else
        texture = SanQuentin2.assetLoader.getTextures("M/7/M_normal");

        this.seq_xWays.setTexture(texture!);

        this.seq_xWays.anchor.y = isTop ?  0 : 1;
        this.seq_xWays.position.y = isTop ? -this.halfhalfSymHeight : this.halfhalfSymHeight;
    }

    public xWaysReset(): void {
        this.seq_res.visible = true;
        if(this.specSym && this.specSym.sym == this.seq_res.symName){
            this.seq_res.isSpecial(this.specSym.val,0);
        }
    }

    public revealRes(durr: number): void {
        gsap.to(this.seq_xWays, durr, { alpha: 0 })
    }

    public expand(expands: boolean): gsap.core.Timeline {

        const durrExp: number = GameConfig.REEL_ENGINE_CONFIG.DURATION.EXPAND!;
        const easeing: any = GameConfig.REEL_ENGINE_CONFIG.EASING.EXPAND;

        this.expand_tl = Helper.setTimeline(this.expand_tl, {
            onStart: () => {
                this.useOverlayGlow(false);
                this.seq_res.visible = !expands;
                this.seq_xWays.alpha = expands ? 1  : 0 ;
            },
            onComplete: () => {
                {
                    this.seq_res.visible = !expands;
                }
            }
        });

        if(expands){
            this.expand_tl.fromTo(this.seq_xWays.scale, { y:  0.25 }, {
                y:  1,
                ease: easeing,
                duration: durrExp
            },0);
        }else{
            this.expand_tl.fromTo(this.seq_res.scale, { y:  0.85 }, {
                y:  1,
                ease: easeing,
                duration: durrExp
            },0);
        }

        return this.expand_tl;
    }
}